import { render, staticRenderFns } from "./NavigationSelect.vue?vue&type=template&id=31927dac"
import script from "./NavigationSelect.vue?vue&type=script&lang=ts"
export * from "./NavigationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports